<template>
    <div class="account-request">
        <!-- <SearchField
			class="search"
            :loading="loading"
			v-model="keyword"
            @input="changeFilter(true)"
		/>

        <AccountRequestControls class="controls"/>

        <DataTable
            :header="listTableHeader"
            :rows="list.data"
            :cells="[
                'request_date', 'company_name', 'full_name', 'email', 'country',
                'full_contact_no', 'status'
            ]"
            :clickable="false"
            :loading="loading"
            :hasNumberColumn="true"
            @select="select($event)"
            @rowClick="$router.push(`/account-overview/${$event.id}`)"
            :selectedItem="selectedAccounts"
            ref="dataTable"
        />

        <Pagination
			class="paginate"
			v-model="params.page"
			:currentPage="parseInt(params.page)"
			:total="list.total"
			:loading="loading"
            :hasPageCount="false"
		/> -->

        <data-container>
            <template slot="controls">
                <SearchField
                    class="search"
                    :loading="loading"
                    v-model="keyword"
                    @input="changeFilter(true)"
                />

                <div class="control-wrapper">
                    <div class="controls">
						<!-- <custom-option
							class="option"
							:options="filterOptions"
							placeholder="Filter by"
							v-model="params.filterBy"
						>
						</custom-option> -->

						<custom-option
							class="option"
							:options="sortOptions"
							placeholder="Sort by"
							v-model="params.sortBy"
						>
                        </custom-option>

                        <!-- <custom-option
							class="option"
							:options="['All']"
                            placeholder=""
                            value="All"
						>
                        </custom-option> -->

                    </div>

                    <AccountRequestControls class="controls"/>
                </div>
            </template>

            <template slot="content">
                <custom-table
                    :fields="fields"
					:items="list.data"
					:current-page="parseInt(params.page)"
					:items-per-page="10"
					:total-count="list.total"
                    hide-per-page-option
                    :is-loading="loading"
					:selected-items="selectedAccounts"
					@changePage="changePage"
                    @click="$router.push(`/account-overview/${$event.id}`)"
                >

                    <section
                        class="actions"
                        slot="actions"
                        slot-scope="{ item }"
                    >
                        <button class="_approve" @click.stop="toggleApproveUserModal(item)">
                            Approve
                        </button>

                        <button class="_deny" @click.stop="rejectUser(item)">
                            Reject
                        </button>
                    </section>
                </custom-table>
            </template>
        </data-container>

        <transition name="transition-anim">
            <Modal v-if="modalName.indexOf('request-form') > -1">
                <AccountForm storeModule="accountRequest" :isApprove="true" slot="content"/>
            </Modal>
        </transition>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import * as accountRequest from '@/store/account-request/app.js'
import CustomOption from '@/components/utils/CustomOption.vue'

import SearchField from '@/components/utils/SearchField'
import CustomTable from '@/components/utils/CustomTable.vue'
import DataContainer from '@/components/layouts/DataContainer.vue'

import AccountRequestControls from '@/components/account-request/AccountRequestControls'
import AccountForm from '@/components/layouts/AccountForm'
export default {
    data () {
        return {
            fields: [
                {text: 'Req.ID', name: 'id'},
				{text: 'Request date', name: 'request_date'},
				{text: 'Company Name', name: 'company_name'},
				{text: `Host Name`, name: 'full_name'},
				{text: 'Email', name: 'email'},
				{text: 'Country', name: 'country'},
                {text: 'User', name: 'user_allocation'},
                {text: 'Account Type', name: 'company_type'}
                // {text: 'Status', name: 'status'},
                // {text: 'Account Type', name: 'is_disabled'}
            ],
            
            sortOptions: ['Latest', 'Oldest'],

			filterOptions: ['Online', 'Offline', 'For Activation'],
            fromPagination: false
        }
    },

    beforeCreate () {
        if (!this.$store._modulesNamespaceMap['accountRequest/']) {
			this.$store.registerModule('accountRequest', accountRequest.default)
        }
    },

    async created () {
        await this.setParams()
    },

    destroyed () {
        this.$store.commit('accountRequest/clearPage')
    },

    computed: {
        ...mapFields('accountRequest', [
            'keyword',
            'params',
            'list',
            'loading',
            'selectedAccounts',
            'hasUpdatedList',
            'isUpdateAccount'
        ]),

        ...mapFields('modal', [
            'modalName',
            'notificationName'
        ]),
        
        // listTableHeader () {
		// 	return [
		// 		'Request date',
		// 		'Company Name',
		// 		`Host Name`,
		// 		'Email',
		// 		'Country',
		// 		'Contact No.',
		// 		'Status'
		// 	]
		// },
    },

    watch: {
        '$route.fullPath': {
            handler: 'getList',
            immediate: true
        },

        params: {
            handler () {
                this.changeFilter()
            },

            deep: true
        }
    },

    methods: {
        /* Activated Lifecycle Method */
        setParams () {
            if (Object.keys(this.$route.query).length) {
                this.params = JSON.parse(JSON.stringify(this.$route.query))

                if (this.$route.query.keyword) this.keyword = this.$route.query.keyword
            }
        },

        changePage ({ currentPage }) {
            this.params.page = currentPage
            this.fromPagination = true
		},

        /* Watcher Methods */
        getList (value) {
            if (this.hasUpdatedList) return
            
            let url = value.replace('/account-request', '/cms/client/list')

            url += Object.keys(this.$route.query).length
                    ? '&account_status=0'
                    : '?account_status=0'

            this.$store.dispatch('accountRequest/getAccountList', url)
        },

        async changeFilter () {
            if (!this.fromPagination) {
                this.params.page = 1
                this.selectedAccounts = []
            }

            const queryParams = {}
            const routeQuery = this.$route.query

			if (this.keyword) queryParams.keyword = this.keyword
			// if (this.params.filterBy) queryParams.filter_by = this.params.filterBy.toLowerCase()
			if (this.params.sortBy) queryParams.order_by = this.params.sortBy.toLowerCase()
			if (this.params.page) queryParams.page = this.params.page

            let isNewParams = true

            if (Object.keys(routeQuery).length === Object.keys(queryParams).length) {
                isNewParams = false

                // Doing this since when on refresh, and there
                // is a $route.query e.g. ('?keyword=sample')
                // it will be assigned to this.params, and will trigger
                // param watcher and could generate a duplicate router push error
                for (const param of Object.keys(queryParams)) {
                    if (`${routeQuery[param]}` !== `${queryParams[param]}`) {
                        isNewParams = true
                        break
                    }
                }
            }
            
            if (isNewParams) this.$router.push({query: queryParams})
            this.fromPagination = false
        },

        async toggleApproveUserModal (user) {
            const { id, country } = user

            if (country) {
                this.getCountryZone(country)
                await this.getPartnerList(country)
            }

            this.isUpdateAccount = true

            this.$router.push(`/account-request/approve/${id}`)
        },

        async getPartnerList (countryName) {
            await this.$store.dispatch('global/getPartnerList', countryName)
        },

        getCountryZone (countryName) {
            this.$store.dispatch('global/getCountryZone', countryName)
        },

        rejectUser (user) {
            const form = new FormData()
            form.append('id', user.id)
            form.append('account_status', 0)

            this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: 'Are you sure you want to reject this account?',
                storeAction: 'accountRequest/rejectAccount',
                storePayload: form
            })
        }
    },

    components: {
        SearchField,
        CustomTable,
        DataContainer,
        AccountForm,
        AccountRequestControls,
        CustomOption,

        Modal: () => import('@/components/utils/Modal')
    },
}
</script>

<style lang="scss" scoped>
.account-request {
    width: 100%;
    height: 100%;

    .control-wrapper {
        margin-top: 15px;
        flex: 1 1 auto;
        width: 100%;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        .controls {
            display: flex;
            justify-content: flex-end;
            > *:not(:first-child) {
                margin-left: 10px;
            }
        }
    }

    /deep/ .id {
        width: 100px;
    }

    /deep/ .request_date {
        width: 110px;
    }

    /deep/ .is_disabled {
        width: 80px;
    }

    /deep/ .status {
        width: 75px;
    }

    .actions {
        display: flex;

        button {
            flex-shrink: 0;

            &:first-child {
                margin-right: 10px;
            }
        }
    }
}
</style>